import { render, staticRenderFns } from "./productSure.vue?vue&type=template&id=62139868&scoped=true"
import script from "./productSure.vue?vue&type=script&lang=js"
export * from "./productSure.vue?vue&type=script&lang=js"
import style0 from "./productSure.vue?vue&type=style&index=0&id=62139868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62139868",
  null
  
)

export default component.exports